<template>
  <div style="padding-top: 150px; margin-bottom: 100px;" id="about">
    <b-container  v-scroll-reveal="{ delay: 20 }">
      
     
      <b-row>
        <b-col lg="3" md="4" style="text-align: center;">
          <img
          width="150"
            style="border-radius: 100%;"
            src="/kat-v2.jpg"/>
            <div class="uni" style="margin-bottom: 50px;">Tampa, FL</div>
        </b-col>
        <b-col lg="9" md="8">
            
            <div style="margin-bottom: 30px;">
              <h2 style="color: #ffa318;">Katherine Pacitti</h2>
              <h5 style="color: #333;">Strategic Communications & Public Relations Professional</h5>
            </div>
            <div>

              I'm a public relations strategist passionate about helping brands, entrepreneurs, and thought leaders define what they want to be known for and communicate that value with clarity and purpose.
              <br/><br/>
              My work is rooted in strategic storytelling, media strategy, personal branding, and visibility. I love helping clients refine the stories that support their vision and identify opportunities that position them for long-term credibility and growth.
              <br/><br/>
              With a background in public relations, digital marketing, project management, and entrepreneurship, I bring a strategic yet creative approach to every project. I enjoy connecting the dots and developing strategies that help clients build meaningful visibility and lasting influence.

              <!-- I'm a proud graduate of the University of Florida with a background in law and a current focus on digital marketing. While working as a legal assistant, I co-founded Eden Couture, a custom festival wear business that introduced me to branding, content creation, and social media strategy. Being a part of Eden showed me where my strengths and interests truly are: creative marketing backed by organization, clear messaging, and brand development.

              <br/><br/>

              My legal background continues to serve me as a project manager, as it taught me how to stay organized under pressure, write persuasively, and think strategically. Now at Your Brand Voice, I lead multi-platform campaigns, write SEO-driven content, design visual assets, and use performance data to drive measurable growth. I bring structure, creativity, and clarity to every project, helping brands connect with the right audience and stand out in a crowded digital space.

              <br/><br/>
              Click <a href="#personal" style="color: #ffa318 !important;">here</a> to see info about Eden Couture LLC. -->
            </div>
            <br/>
            <div style="margin-top: 20px;">
              <b-row>
                <b-col lg="6">
                   <div>
                    Email
                  </div>
                  <div class="text-gray" style="margin-bottom: 20px;">
                    <b>katgpacitti@gmail.com</b>
                  </div>
                </b-col>
                <b-col lg="6">
                  <div>
                    Phone
                  </div>
                  <div class="text-gray">
                    <b>(941) 779-7253</b>
                  </div>
                </b-col>
              </b-row>
            </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="css">
.uni {
  background: #ffa31830;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 6px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  color: #ffa318;
  margin-top: 10px;
  font-weight: bold;
  font-size: 12px;
}

</style>
